<template>
  <div class="text-center">
    <Badge v-if="alarmCount !== null"
           class="text-truncate"
           :color="badgeColorStatusClass"
           :title="badgeTitle"
           :text="alarmCount.toString()"
           pill>
    </Badge>
  </div>
</template>

<script>
  import Badge from '../../../common/layout/Badge.vue';

  export default {
    name: 'AlarmCounter',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Badge,
    },
    data() {
      return {
        alarmCount: null,
      };
    },
    computed: {
      badgeColorStatusClass() {
        return this.alarmCount > 0 ? 'red' : 'green';
      },
      badgeTitle() {
        return `${this.params.tooltipLabel}: ${this.alarmCount}`;
      },
    },
    mounted() {
      this.alarmCount = this.params.value;
    },
  };
</script>
